import React, { useCallback, useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./admin.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faChevronLeft, faChevronRight, faCircleDown, faCirclePause, faCopy, faFilter, faFilterCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { apiService } from '../../services/apiService';
import Box from '@mui/material/Box';
import { Avatar, MenuItem, TextField, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Select from 'react-select';
import AdminRoletabs from '../../components/common/AdminRoletabs';
import { AsyncPaginate } from 'react-select-async-paginate';
import { useTableExport } from '../../components/exporttable/useTableExport';
import ExportDialogs from '../../components/exporttable/ExportDialogs';
const profileImage = require('../../assets/defaultprofile.svg').default;

function UserJobSeekers() {
    const navigate = useNavigate();

    // 🔹 session storage helpers
    const SS_PREFIX = 'userJobSeekers_';
    const getStored = (key, fallback) => {
        try {
            const v = sessionStorage.getItem(SS_PREFIX + key);
            return v !== null ? JSON.parse(v) : fallback;
        } catch {
            return fallback;
        }
    };

    // 🔹 build the lane-view applied payload from stored filters (mirrors handleSearch)
    const buildLanePayload = () => {
        const payload = {};
        const addIfNotEmpty = (key, value) => {
            if (value !== "") {
                payload[key] = value;
            }
        };
        addIfNotEmpty("onboarding_hold", getStored('selectedOnboard', ''));
        addIfNotEmpty("training_status", getStored('trainStatus', ''));
        return payload;
    };

    const [seekerData, setSeekerData] = useState([]);
    const [seekerData2, setSeekerData2] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingLanedata, setLoadingLanedata] = useState(true);
    const [loadingApply, setLoadingApply] = useState(false);
    const [loadingApply2, setLoadingApply2] = useState(false);
    const [groupByColumn, setGroupByColumn] = useState(() => getStored('groupByColumn', 'stage'));
    const [showLaneview, setLaneView] = useState(() => getStored('showLaneview', false));

    const [laneLoading, setLaneLoading] = useState({});
    const pageRefs = useRef({}); // { [group_id]: currentPage }
    const searchParamsRef = useRef(buildLanePayload());
    // 🔹 skip the first auto table-load lane reset when restoring lane view
    const skipLaneResetRef = useRef(getStored('showLaneview', false) === true);
    const fetchMyRequest = useCallback(async (params = {}, columnPage = null, showLoader = true) => {
        if (showLoader) setLoadingApply2(true);
        if (showLaneview === true){
            try {
                const defaultParams = {
                    view: "lane", 
                    group_by: groupByColumn, 
                    ...params,
                    ...searchParamsRef.current,
                    ...(columnPage && { column_page: columnPage }),
                };

                const response = await apiService.postRequest(`/admin/jobseekers`, defaultParams);

                if (response.success === true) {
                    if (columnPage) {
                        // PAGINATION: append data only to matching lanes
                        setSeekerData2(prev =>
                            prev.map(lane => {
                                const groupId = String(lane.group_id);
                                if (columnPage[groupId]) {
                                    const incomingLane = response.columns.find(
                                        col => String(col.group_id) === groupId
                                    );
                                    if (incomingLane) {
                                        return {
                                            ...lane,
                                            data: [...(lane.data || []), ...(incomingLane.data || [])],
                                            has_more: incomingLane.has_more,
                                            total: incomingLane.total,
                                        };
                                    }
                                }
                                return lane;
                            })
                        );
                    } else {
                        // FRESH LOAD: replace all data & reset pages
                        pageRefs.current = {};
                        setSeekerData2(response.columns);
                        setFilters([{ logic: 'and', column: 'formatted_id', operator: 'contains', value: '' }]);
                    }
                }
            } catch (error) {
                console.error('Error fetching list:', error);
            } finally {
                if (!columnPage) setLoading(false);
                setLoadingApply2(false);
                setLoadingLanedata(false);
            }
        }
    }, [groupByColumn, showLaneview]);


    const handleLoadMore = useCallback(async (groupId) => {
        if (laneLoading[groupId]) return;

        setLaneLoading(prev => ({ ...prev, [groupId]: true }));

        try {
            const nextPage = (pageRefs.current[groupId] || 1) + 1;
            pageRefs.current[groupId] = nextPage;

            const columnPage = { [groupId]: nextPage };

            await fetchMyRequest({}, columnPage);
        } catch (err) {
            console.error('Failed to load more:', err);
        } finally {
            setLaneLoading(prev => ({ ...prev, [groupId]: false }));
        }
    }, [laneLoading, fetchMyRequest]);


    const handleSearch = () => {
        const payload = {};

        const addIfNotEmpty = (key, value) => {
            if (value !== "") {
                payload[key] = value;
            }
        };

        addIfNotEmpty("onboarding_hold", selectedOnboard);
        addIfNotEmpty("training_status", trainStatus);
        searchParamsRef.current = payload;
        pageRefs.current = {};
        fetchMyRequest(payload);
    };

    const handleClear = () => {
        // Clear all selected dropdowns
        setTrainStatus('');
        setSelectedOnboard('');

        // Reset stored search params
        searchParamsRef.current = {};

        // Reset pagination
        pageRefs.current = {};

        // Fetch default data (without filters)
        fetchMyRequest({}, null, false);
    };

    useEffect(() => {
        fetchMyRequest();
    }, [fetchMyRequest]);

    
    const observerRefs = useRef({});

    const setObserver = useCallback((groupId, hasMore) => (node) => {
        // Disconnect existing observer for this lane
        if (observerRefs.current[groupId]) {
            observerRefs.current[groupId].disconnect();
            delete observerRefs.current[groupId];
        }

        if (!node || !hasMore) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    handleLoadMore(groupId);
                }
            },
            { threshold: 0.1 }
        );

        observer.observe(node);
        observerRefs.current[groupId] = observer;
    }, [handleLoadMore]);

    // Cleanup all observers on unmount
    useEffect(() => {
    const observers = observerRefs.current; // 👈 copy to local variable
        return () => {
            Object.values(observers).forEach(obs => obs.disconnect());
        };
    }, []);

    const [isGridVisible, setGridVisible] = useState(false);
    const [selectedOnboard, setSelectedOnboard] = useState(() => getStored('selectedOnboard', ''));
    const [trainStatus, setTrainStatus] = useState(() => getStored('trainStatus', ''));

    // Lane View
    const MySeekerCard = ({ SeekerLaneData }) => {
        return (
            <div className="scrum-card">
                <div className="card-header">
                    <Link className='link_datatspan hover_underline' to={`/user/jobseeker-details/${SeekerLaneData.id}`} target='_blank' style={{color:"#C42B7D",textDecoration:"none"}}>
                        {SeekerLaneData.format_id}
                    </Link>
                    <div className='d-flex gap-2'>
                        {SeekerLaneData?.marketing_risk_level && SeekerLaneData.marketing_risk_level === "safe" &&
                        <p className='text-uppercase' 
                        style={{color: SeekerLaneData.marketing_risk_level === "safe" ? "#159b20" : "#212529"}}
                        >{SeekerLaneData.marketing_risk_level}</p>
                        }
                        {SeekerLaneData?.onboarding_case_status === "hold" &&
                            <FontAwesomeIcon style={{color:"#d84242"}} icon={faCirclePause} />
                        }
                    </div>
                </div>
                <div className="d-flex align-items-center mb-2">
                    <Avatar src={SeekerLaneData.profile || profileImage} alt={SeekerLaneData.name} style={{ width: 32, height: 32 }} />
                    <span className='ms-2 text-start' style={{ fontSize: '13px', fontWeight: '600' }}>{SeekerLaneData.name}</span>
                </div>
                {SeekerLaneData.visa && <p style={{ marginBottom: '4px' }}><strong>Visa:</strong> {SeekerLaneData.visa} <strong>Age:</strong> {SeekerLaneData.age}</p>}
                {SeekerLaneData.placement_manager && <p style={{ marginBottom: '4px' }}><strong>Placement Manager:</strong> {SeekerLaneData.placement_manager}</p>}
                {SeekerLaneData.sub_stage && groupByColumn === "stage" && <p style={{ marginBottom: '4px' }}><strong>Sub stage:</strong> {SeekerLaneData.sub_stage}</p>}
                {SeekerLaneData.sub_stage_updated_at && <p style={{ marginBottom: '4px' }}><strong>Sub stage updated on:</strong> {SeekerLaneData.sub_stage_updated_at}</p>}
                {SeekerLaneData.certifications?.length > 0 && <p style={{ marginBottom: '4px' }}><strong>Certifications:</strong> {SeekerLaneData.certifications.join(", ")}</p>}
                {SeekerLaneData.training_programs && SeekerLaneData.training_programs?.length > 0 && <p style={{ marginBottom: '4px' }}><strong>Training:</strong> 
                {SeekerLaneData.training_programs?.map((traindata, index) => (
                    <div style={{color: traindata?.status === "in-progress" ? "#1500ff" :
                        traindata?.status === "pending" ? "#000" : 
                        traindata?.status === "completed" ? "#159b20" :
                        traindata?.status === "failed" ? "#ff6333" : 
                        traindata?.status === "skipped" ? "#000" : 
                        ""}}>
                        {traindata.program_name}
                    </div>
                ))}</p>}
            </div>
        );
    };

    const groupByOptions = [
        { value: "stage", label: "Stage" },
        { value: "sub_stage", label: "Sub Stage" },
    ];

    const toggleGrid = () => {
        setGridVisible((prev) => !prev);
    };
    const toggleLaneview = () => {
        setLaneView((prev) => {
            if (!prev && !loadingLanedata) {
                setLoadingLanedata(true);
            }
            return !prev;
        });
    };

    // Tableview with filter
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedRecord, setShowRecord] = useState(20);
    const [loadingPage, setLoadingPage] = useState(false);
    const [applyFilData, setApplyfilData] = useState(() => getStored('applyFilData', []));
    const [uniqueCityStatuses, setCitizenshipStatuses] = useState([]);

    const fetchRoots = useCallback(async (params = {}) => {
        setLoadingApply(true);
        try {
            const defaultParams = {  
                    per_page: params?.per_page ?? selectedRecord,
                    filters: params?.filters ?? applyFilData,
                    ...params};
            const response = await apiService.postRequest(`/admin/jobseekers`, defaultParams);
            if(response.success === true){
                setSeekerData(response.data);
                setPaginateData(response.meta);
                if (skipLaneResetRef.current) {
                    skipLaneResetRef.current = false;
                } else {
                    setLaneView(false);
                }
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
            setLoadingApply(false);
            setLoadingPage(false);
        }
    }, [applyFilData, selectedRecord]);

    const handleSearchTable = () => {
        setApplyfilData(filters);
        fetchRoots({ filters });
        setCurrentPage(1);
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchRoots({ page: newPage, filters: applyFilData });
        setLoadingPage(true);
    };

    useEffect(() => {
        fetchRoots();
    }, [fetchRoots]);

    const [filters, setFilters] = useState(() => getStored('filters', [{ logic: 'and', column: 'formatted_id', operator: 'contains', value: '' }]));

    const combineOptions = [
        { value: 'and', label: 'And' },
        { value: 'or', label: 'Or' },
    ];
    
    const rows = seekerData.map((datas) => ({
        id: datas.id,
        formatid: datas.format_id,
        userName: datas.name,
        userImage: datas.profile || profileImage,
        status: datas.status_details?.label,
        cityStatus:datas.citizenship_status,
        city:datas.city,
        state:datas.state_name,
        stage:datas.stage,
        subStage:datas.sub_stage,
        refereName:datas.referrer_name,
        contactPhone: datas.phone_number,
        contactEmail: datas.email,
        date_created: datas.created_at,
        created_by: datas.created_by,
        updated_on: datas.updated_at,
        updated_by: datas.updated_by,
        zipcode: datas.zipcode,
        address: datas.personal_info.address,
        dob: datas.personal_info.dob,
        awaiting_ead_card: datas.immigration_data && datas.immigration_data.awaiting_ead_card,
        ead_card_applied_date: (datas.immigration_data && datas.immigration_data.ead_card_applied_date) || "No data",
        legally_authorized_to_work: datas.immigration_data && datas.immigration_data.legally_authorized_to_work,
        work_authorization_expiry: datas.immigration_data && datas.immigration_data.work_authorization_expiry,
        renew_authorization_work: datas.immigration_data && datas.immigration_data.renew_authorization_work,
        ssn_issue_year: datas.immigration_data && datas.immigration_data.ssn_issue_year,
        emergency_first_name: datas.emergency_contact && datas.emergency_contact.first_name,
        emergency_last_name: datas.emergency_contact && datas.emergency_contact.last_name,
        emergency_phone_number: datas.emergency_contact && datas.emergency_contact.phone_number,
        emergency_relation_type: datas.emergency_contact && datas.emergency_contact.relation_type,
        referrer_phone_number: datas.referral_info && datas.referral_info.referral_phone_number,
        referrer_relationship: datas.referral_info && datas.referral_info.referrer_relationship,
        current_onboarding_status: datas?.current_onboarding_status_string,
    }));

    const columnFieldToCSVKey = {
        formatid: 'ID',
        userName: 'Name',
        cityStatus: 'Citizenship Status',
        city: 'City',
        state: 'State',
        stage: 'Stage',
        subStage: 'Sub Stage',
        refereName: 'Referrer Name',
        contactPhone: 'Phone Number',
        contactEmail: 'Email',
        status: 'Status',
        date_created: 'Created On',
        created_by: 'Created By',
        updated_on: 'Updated On',
        updated_by: 'Updated By',
        zipcode: 'Zip Code',
        address: 'Address',
        dob: 'Date of Birth',
        awaiting_ead_card: 'Awaiting EAD Card',
        ead_card_applied_date: 'EAD Card Applied Date',
        legally_authorized_to_work: 'Legally Authorized To Work',
        work_authorization_expiry: 'Work Authorization Expiry',
        renew_authorization_work: 'Renew Authorization Work',
        ssn_issue_year: 'SSN Issue Year',
        emergency_first_name: 'Emergency First Name',
        emergency_last_name: 'Emergency Last Name',
        emergency_phone_number: 'Emergency Phone Number',
        emergency_relation_type: 'Emergency Relation Type',
        referrer_phone_number: 'Referrer Phone Number',
        referrer_relationship: 'Referrer Relationship',
        current_onboarding_status: 'Current Onboarding Status',
    };

    const getVisibleRowData = (row) => {
        console.log("row",row)
        const fullRow = {
            'ID': row.format_id,
            'Name': row.name,
            'Citizenship Status': row?.immigration_data?.citizenship_status,
            'City': row.city,
            'State': row.state_name,
            'Stage': row.stage,
            'Sub Stage': row.sub_stage,
            'Referrer Name': row.referrer_name,
            'Phone Number': row.phone_number,
            'Email': row.email,
            'Status': row.status,
            'Created On': row.created_at,
            'Created By': row.created_by,
            'Updated On': row.updated_at,
            'Updated By': row.updated_by,
            'Zip Code': row.zipcode,
            'Address': row.address,
            'Date of Birth': row.dob,
            'Awaiting EAD Card': row?.immigration_data?.awaiting_ead_card,
            'EAD Card Applied Date': row?.immigration_data?.ead_card_applied_date,
            'Legally Authorized To Work': row?.immigration_data?.legally_authorized_to_work,
            'Work Authorization Expiry': row?.immigration_data?.work_authorization_expiry,
            'Renew Authorization Work': row?.immigration_data?.renew_authorization_work,
            'SSN Issue Year': row?.immigration_data?.ssn_issue_year,
            'Emergency First Name': row?.emergency_contact?.first_name,
            'Emergency Last Name': row?.emergency_contact?.last_name,
            'Emergency Phone Number': row?.emergency_contact?.phone_number,
            'Emergency Relation Type': row?.emergency_contact?.relation_type,
            'Referrer Phone Number': row?.referral_info?.referral_phone_number,
            'Referrer Relationship': row?.referral_info?.referrer_relationship,
            'Current Onboarding Status': row?.current_onboarding_status_string,
        };

        const visibleCSVKeys = Object.entries(columnFieldToCSVKey)
            .filter(([field]) => columnVisibilityModel[field] !== false)
            .map(([, csvKey]) => csvKey);

        return Object.fromEntries(
            Object.entries(fullRow).filter(([key]) => visibleCSVKeys.includes(key))
        );
    };

    // 🔹 Build the body for the server-side export endpoint.
    //    Uses the *applied* search/filters (not the unsaved inputs).
    const buildExportParams = () => ({
        // filter: 'all',            // same value fetchRoots sends for this page
        // case_type: selectedCase,
        // search: searchQueryApi,
        filters: applyFilData,
    });

    // 🔹 Reusable export logic: pulls the FULL filtered dataset from
    //    /my-tasks/export, then downloads CSV or copies to clipboard.
    //    Handles the >10k email prompt and the background-running modal.
    const {
        exporting,
        prompt,
        requestExport,
        confirmEmail,
        confirmContinue,
        cancelPrompt,
    } = useTableExport({
        endpoint: '/admin/export-jobseekers-new',
        endpointMail: '/send-mail-once-exported-the-tasks',
        mailFileBase: 'jobseeker_export',
        mapRow: getVisibleRowData,   // respects hidden columns
        fileName: 'jobseeker.csv',
    });

    const downloadCSV = () =>
        requestExport('download', {
            totalCount: paginatedata?.total ?? 0,
            params: buildExportParams(),
        });

    const  copyToClipboard = () =>
        requestExport('copy', {
            totalCount: paginatedata?.total ?? 0,
            params: buildExportParams(),
        });
    
    const [relationships, setRelationships] = useState([]);
    const [referrers, setReferrers] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.postRequest('generalsettings-data');
            if (response.success) {
                setCitizenshipStatuses(response.citizenship_statuses);
                setRelationships(response.relationships);
                setReferrers(response.referrers);
            }
        };
        fetchData();
    }, []);

    const [stageOptions, setStageOptions] = useState([]);
    const loadOptionsStages = async (searchQuery, loadedOptions, { page }) => {
        const params = {
            search: searchQuery,
            page : page
        }
        try {
        const response = await apiService.postRequest(
            `admin/jobseeker/dropdown-stages-list`, params
        );
        if(response && response.success === true){
            const newOptions = response?.data?.map(item => ({
                value: item.id,
                label: item.value,
            }));

            setStageOptions(prev => {
                const combined = [...prev, ...newOptions];
                const unique = Array.from(
                    new Map(combined.map(item => [item.value, item])).values()
                );
                return unique;
            });

        return {
            options: response?.data?.map(item => ({
            value: item.id,
            label: item.value,
            })),
            hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
            additional: {
            page: page + 1,
            },
        };
        }else{
            return {
                options: [],
                hasMore: false,
            };
        }} catch (error) {
        console.error('Error loading options:', error);
        return {
            options: [],
            hasMore: false,
        };
        }
    };

    const [subStageOptions, setSubStageOptions] = useState([]);
    const loadOptionsSubStages = async (searchQuery, loadedOptions, { page }) => {
        const params = {
            search: searchQuery,
            page : page
        }
        try {
        const response = await apiService.postRequest(
            `admin/jobseeker/dropdown-sub-stages-list`, params
        );
        if(response && response.success === true){
            const newOptions = response?.data?.map(item => ({
                value: item.id,
                label: item.value,
            }));

            setSubStageOptions(prev => {
                const combined = [...prev, ...newOptions];
                const unique = Array.from(
                    new Map(combined.map(item => [item.value, item])).values()
                );
                return unique;
            });

        return {
            options: response?.data?.map(item => ({
            value: item.id,
            label: item.value,
            })),
            hasMore: response?.meta?.current_page === response?.meta?.last_page ? false : true,
            additional: {
            page: page + 1,
            },
        };
        }else{
            return {
                options: [],
                hasMore: false,
            };
        }} catch (error) {
        console.error('Error loading options:', error);
        return {
            options: [],
            hasMore: false,
        };
        }
    };

    const handleFilterChange = (index, field, value) => {
        const updated = [...filters];
        if (field === "column") {
            updated[index][field] = value;

            if (value === "created_on" || value === "updated_on") {
                updated[index].operator = "range";
                updated[index].value = "today";
            } else if (value === "dob" || value === "ssn_issue_year" || value === "ead_card_applied_date" || value === "work_authorization_expiry") {
                updated[index].operator = "on";
                updated[index].value = "";
            } else {
                updated[index].operator = "contains";
                updated[index].value = "";
            }

            delete updated[index].start_date;
            delete updated[index].end_date;

        } else if (field === "value" && updated[index].operator === "range") {
            updated[index].value = value;

            if (value !== "custom") {
                delete updated[index].start_date;
                delete updated[index].end_date;
            }

        } else if (field === "operator") {
            const wasMulti = updated[index].operator === "is_one_of" || updated[index].operator === "is_not_one_of";
            const isNowMulti = value === "is_one_of" || value === "is_not_one_of";

            updated[index][field] = value;

            // Clear value when switching between single <-> multi select
            if (wasMulti !== isNowMulti) {
                updated[index].value = isNowMulti ? [] : "";
            }

        } else {
            updated[index][field] = value;
        }

        setFilters(updated);
    };

    const addFilter = () => {
        setFilters([...filters, { logic: 'and', column: 'formatted_id', operator: 'contains', value: '' }]);
    };

    const removeFilter = (index) => {
        setFilters(filters.filter((_, i) => i !== index));
    };
    
    const operatorOptions = [
        { value: 'contains', label: 'Contains' },
        { value: 'does_not_contain', label: 'Does Not Contain' },
        { value: 'starts_with', label: 'Starts With' },
        { value: 'ends_with', label: 'Ends With' },
        { value: 'is', label: 'Is' },
        { value: 'is_not', label: 'Is Not' },
        { value: 'is_empty', label: 'Is Empty' },
        { value: 'is_not_empty', label: 'Is Not Empty' },
    ];
    
    const getOperatorOptions = (column) => {
        if (column === 'citizenship_status' || column === 'stage' || column === 'sub_stage' || column === 'current_onboarding_status' || column === 'emergency_relation_type' || column === 'referrer_relationship' ) {
            return [
                { value: 'contains', label: 'Contains' },
                { value: 'does_not_contain', label: 'Does Not Contain' },
                { value: 'starts_with', label: 'Starts With' },
                { value: 'ends_with', label: 'Ends With' },
                { value: 'is_one_of', label: 'Is One Of' },
                { value: 'is_not_one_of', label: 'Is Not One Of' },
                { value: 'is', label: 'Is' },
                { value: 'is_not', label: 'Is Not' },
                { value: 'is_empty', label: 'Is Empty' },
                { value: 'is_not_empty', label: 'Is Not Empty' },
            ];
        }
        else if (column === 'ead_card_applied_date' || column === 'dob' || column === 'work_authorization_expiry' || column === 'date_created' || column === 'ssn_issue_year') {
            return [
                { value: 'on', label: 'On' },
                { value: 'not_on', label: 'Not On' },
                { value: 'before', label: 'Before' },
                { value: 'at_or_before', label: 'At Or Before' },
                { value: 'after', label: 'After' },
                { value: 'at_or_after', label: 'At Or After' },
                { value: 'between', label: 'Between' },
                { value: 'is_empty', label: 'Is Empty' },
                { value: 'is_not_empty', label: 'Is Not Empty' },
            ];
        }
        else if (column === 'created_on' || column === "updated_on") {
            return [
                { value: 'range', label: 'Range' },
            ];
        }
        return operatorOptions; // Default options
    };
    

    const columns = [
        {
            field: 'formatid',
            headerName: 'ID',
            width: 250,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <Link to={`/user/jobseeker-details/${params.row.id}`} target='_blank' className='cursetespoint hover_underline' style={{color:"#C42B7D",textDecoration:"none"}} >{params.row.formatid}</Link>
                </div>
            ),
            filterable: true,
        },
        {
            field: 'userName',
            headerName: 'User',
            width: 250,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <Avatar src={params.row.userImage} alt={params.row.userName} />
                    <span className='ms-3'>{params.row.userName}</span>
                </div>
            ),
            filterable: true
        },
        {
            field: 'cityStatus',
            headerName: 'Citizenship Status',
            width: 200,
            filterable: true,
        },
        {
            field: 'dob',
            headerName: 'Date of Birth',
            width: 200,
            filterable: true,
        },
        
        {
            field: 'contactEmail',
            headerName: 'Email',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <Box className="linklistview h-100 d-flex align-items-center">
                    <Typography><span><a href={`mailto:${params.row.contactEmail}`} target="_blank" rel="noopener noreferrer">{params.row.contactEmail}</a></span></Typography>
                </Box>
            )
        },
        {
            field: 'contactPhone',
            headerName: 'Phone',
            width: 250,
            filterable: true,
            renderCell: (params) => (
                <Box className="linklistview h-100 d-flex align-items-center">
                    <Typography><span><a href={`tel:${params.row.contactPhone}`} target="_blank" rel="noopener noreferrer">{params.row.contactPhone}</a></span></Typography>
                </Box>
            )
        },
        {
            field: 'state',
            headerName: 'State',
            width: 200,
            filterable: true,
        },
        {
            field: 'city',
            headerName: 'City',
            width: 200,
            filterable: true,
        },
        {
            field: 'address',
            headerName: 'Address',
            width: 200,
            filterable: true,
        },
        {
            field: 'zipcode',
            headerName: 'Zipcode',
            width: 200,
            filterable: true,
        },
        {
            field: 'awaiting_ead_card',
            headerName: 'Awaiting EAD Card',
            width: 200,
            filterable: true,
        },
        {
            field: 'ead_card_applied_date',
            headerName: 'EAD card applied date',
            width: 200,
            filterable: true,
        },
        {
            field: 'legally_authorized_to_work',
            headerName: 'Legally authorized to work',
            width: 200,
            filterable: true,
        },
        {
            field: 'work_authorization_expiry',
            headerName: 'Work authorization Expiry',
            width: 200,
            filterable: true,
        },
        {
            field: 'renew_authorization_work',
            headerName: 'Renew authorization work',
            width: 200,
            filterable: true,
        },
        {
            field: 'ssn_issue_year',
            headerName: 'SSN issue year',
            width: 200,
            filterable: true,
        },
        {
            field: 'emergency_first_name',
            headerName: 'Emergency contact First Name',
            width: 200,
            filterable: true,
        },
        {
            field: 'emergency_last_name',
            headerName: 'Emergency contact Last Name',
            width: 200,
            filterable: true,
        },
        {
            field: 'emergency_phone_number',
            headerName: 'Emergency contact Phone Number',
            width: 200,
            filterable: true,
        },
        {
            field: 'emergency_relation_type',
            headerName: 'Emergency contact Relation Type',
            width: 200,
            filterable: true,
        },
        {
            field: 'refereName',
            headerName: 'Referrer Name',
            width: 200,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span style={{color:"#C42B7D"}}>{params.row.refereName}</span>
                    {/* <span className='cursetespoint' style={{color:"#C42B7D"}} onClick={() => setShowRefere(true)}>{params.row.refereName}</span> */}
                </div>
            ),
            filterable: true,
        },
        {
            field: 'referrer_phone_number',
            headerName: 'Referrer Phone Number',
            width: 200,
            filterable: true,
        },
        {
            field: 'referrer_relationship',
            headerName: 'Referrer Relation Type',
            width: 200,
            filterable: true,
        },
        {
            field: 'date_created',
            headerName: 'Created',
            width: 200,
            filterable: true,
        },
        {
            field: 'created_by',
            headerName: 'Created By',
            width: 200,
            filterable: true,
        },
        {
            field: 'updated_on',
            headerName: 'Updated',
            width: 200,
            filterable: true,
        },
        {
            field: 'updated_by',
            headerName: 'Updated By',
            width: 200,
            filterable: true,
        },
        {
            field: 'stage',
            headerName: 'Stage',
            width: 200,
            filterable: true,
        },
        {
            field: 'subStage',
            headerName: 'Sub Stage',
            width: 200,
            filterable: true,
        },
        {
            field: 'current_onboarding_status',
            headerName: 'Current Onboarding Status',
            width: 250,
            filterable: true,
        },
    ];

    const [columnVisibilityModel, setColumnVisibilityModel] = useState(() => getStored('columnVisibility', {
        zipcode: false,
        address: false,
        awaiting_ead_card: false,
        ead_card_applied_date: true,
        legally_authorized_to_work: false,
        work_authorization_expiry: false,
        renew_authorization_work: false,
        ssn_issue_year: false,
        emergency_first_name: false,
        emergency_last_name: false,
        emergency_phone_number: false,
        emergency_relation_type: false,
        referrer_phone_number: false,
        referrer_relationship: false
    }));

    // 🔹 persist all filter / column / lane-filter state to session storage
    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'columnVisibility', JSON.stringify(columnVisibilityModel));
    }, [columnVisibilityModel]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'filters', JSON.stringify(filters));
    }, [filters]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'applyFilData', JSON.stringify(applyFilData));
    }, [applyFilData]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'groupByColumn', JSON.stringify(groupByColumn));
    }, [groupByColumn]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'selectedOnboard', JSON.stringify(selectedOnboard));
    }, [selectedOnboard]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'trainStatus', JSON.stringify(trainStatus));
    }, [trainStatus]);

    useEffect(() => {
        sessionStorage.setItem(SS_PREFIX + 'showLaneview', JSON.stringify(showLaneview));
    }, [showLaneview]);

    const columnOptions = [
        { label: "ID", value: "formatted_id" },
        { label: "User Name", value: "user_name" },
        { label: "Citizenship Status", value: "citizenship_status" },
        { label: "Date of Birth", value: "dob" },
        { label: "Created", value: "created_on" },
        { label: "Created By", value: "created_by" },
        { label: "Updated", value: "updated_on" },
        { label: "Updated By", value: "updated_by" },
        { label: "Stage", value: "stage" },
        { label: "Sub Stage", value: "sub_stage" },
        { label: "Current Onboarding Status", value: "current_onboarding_status" },
        { label: "Contact Email", value: "contact_email" },
        { label: "Phone Number", value: "phone_number" },
        { label: "State", value: "state" },
        { label: "City", value: "city" },
        { label: "Zipcode", value: "zipcode" },
        { label: "Address", value: "address" },
        { label: "Referrer Name", value: "referrer_name" },
        { label: "Awaiting EAD card", value: "awaiting_ead_card" },
        { label: "EAD card applied date", value: "ead_card_applied_date" },
        { label: "Legally authorized to work", value: "legally_authorized_to_work" },
        { label: "Work authorization expiry", value: "work_authorization_expiry" },
        { label: "Renew authorization work", value: "renew_authorization_work" },
        { label: "SSN issue year", value: "ssn_issue_year" },
        { label: "Emergency Contact First name", value: "emergency_first_name" },
        { label: "Emergency Contact Last name", value: "emergency_last_name" },
        { label: "Emergency Contact Phone number", value: "emergency_phone_number" },
        { label: "Emergency Contact Relation type", value: "emergency_relation_type" },
        { label: "Referrer Phone number", value: "referrer_phone_number" },
        { label: "Referrer Relation Type", value: "referrer_relationship" },
    ];
    const statusOption = [
        {label: "Pending", value: "pending"},
        {label: "In-Progress", value: "in-progress"},
        {label: "Completed", value: "completed"},
        {label: "Rejected", value: "rejected"},
        {label: "Hold", value: "hold"},
        {label: "Suspended", value: "suspended"},
    ]
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between">
                    <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>User</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> User <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Jobseekers</span>
                    </Grid>
                    <Grid size={{xs:12}} container justifyContent="space-between" className="statusselectbtn my-4">
                        <Grid size={{xs:12}} container>
                            <AdminRoletabs/>
                        </Grid>
                    </Grid>
                </Grid>
                {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    <Box sx={{width:"100%"}} className="datatable_jobpagi">
                        {isGridVisible && !showLaneview && (
                        <Box sx={{ mb: 2 }} className="my-4">
                            {filters.map((filter, index) => (
                                <Box key={index} className="d-flex align-items-start flex-wrap">
                                    {index > 0 && (
                                        <select
                                            label="Combine"
                                            value={filter.logic}
                                            onChange={(e) => handleFilterChange(index, 'logic', e.target.value)}
                                            sx={{ mr: 1, minWidth: 80,mb:1 }}
                                        >
                                            {combineOptions.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    )}
                                    <TextField
                                        select
                                        label="Column"
                                        value={filter.column}
                                        onChange={(e) => handleFilterChange(index, 'column', e.target.value)}
                                        sx={{ mr: 1, minWidth: 120,mb:1 }}
                                    >
                                        {columnOptions?.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        label="Operator"
                                        value={filter.operator}
                                        onChange={(e) => handleFilterChange(index, 'operator', e.target.value)}
                                        sx={{ mr: 1, minWidth: 120,mb:1 }}
                                    >
                                        {getOperatorOptions(filter.column).map((option) => (
                                            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                        ))}
                                    </TextField>
                                    {filter.operator === "is_not_empty" || filter.operator === "is_empty" ? "" :<>
                                        {filter.column === 'current_onboarding_status' && !(filter.operator === "is_not_one_of" || filter.operator === "is_one_of") ? (
                                            <select
                                                label="Value"
                                                value={filter.value}
                                                onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                sx={{ mr: 1, minWidth: 120,mb:1 }}
                                            >
                                                <option value="" disabled>Select Status</option>
                                                {statusOption?.map((option) => (
                                                    <option key={option.value} value={option.value}>{option.label}</option>
                                                ))}
                                            </select>
                                        ) :  filter.column === 'current_onboarding_status' && (filter.operator === "is_not_one_of" || filter.operator === "is_one_of")  ? (
                                            <Select
                                                isMulti
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                options={statusOption.map(status => ({
                                                    label: status.label,
                                                    value: status.value
                                                }))}
                                                value={
                                                    Array.isArray(filter.value)
                                                        ? filter.value.map(val => {
                                                            const matched = statusOption.find(s => s.value === val);
                                                            return {
                                                                label: matched ? matched.label : val,
                                                                value: val
                                                            };
                                                        })
                                                        : []
                                                }
                                                onChange={(selectedOptions) => 
                                                    handleFilterChange(index, 'value', selectedOptions.map(option => option.value))
                                                }
                                                placeholder="Select Onboarding Status"
                                                styles={{ container: (provided) => ({ ...provided, minWidth: 120, marginRight: '8px' }) }}
                                            />
                                        ): filter.column === 'emergency_relation_type' && !(filter.operator === "is_not_one_of" || filter.operator === "is_one_of") ? (
                                            <select
                                                label="Value"
                                                value={filter.value}
                                                onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                sx={{ mr: 1, minWidth: 120,mb:1 }}
                                            >
                                                <option value="" disabled>Select</option>
                                                {relationships.map((relationship) => (
                                                    <option key={relationship.id} value={relationship.value}>
                                                    {relationship.value}
                                                    </option>
                                                ))}
                                            </select>
                                        ) :  filter.column === 'emergency_relation_type' && (filter.operator === "is_not_one_of" || filter.operator === "is_one_of")  ? (
                                            <Select
                                                isMulti
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                options={relationships.map(status => ({
                                                    label: status.value,
                                                    value: status.value
                                                }))}
                                                value={Array.isArray(filter.value) ? filter.value.map(val => ({ label: val, value: val })) : []}
                                                onChange={(selectedOptions) => 
                                                    handleFilterChange(index, 'value', selectedOptions.map(option => option.value))
                                                }
                                                placeholder="Select Onboarding Status"
                                                styles={{ container: (provided) => ({ ...provided, minWidth: 120, marginRight: '8px' }) }}
                                            />
                                        ): filter.column === 'referrer_relationship' && !(filter.operator === "is_not_one_of" || filter.operator === "is_one_of") ? (
                                            <select
                                                label="Value"
                                                value={filter.value}
                                                onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                style={{ mr: 1, minWidth: 120,mb:1 }}
                                            >
                                                <option value="" disabled>Select</option>
                                                {referrers.map((relationship) => (
                                                    <option key={relationship.id} value={relationship.value}>
                                                    {relationship.value}
                                                    </option>
                                                ))}
                                            </select>
                                        ) :  filter.column === 'referrer_relationship' && (filter.operator === "is_not_one_of" || filter.operator === "is_one_of")  ? (
                                            <Select
                                                isMulti
                                                className="basic-single select_withsearch"
                                                classNamePrefix="select"
                                                options={referrers.map(status => ({
                                                    label: status.value,
                                                    value: status.value
                                                }))}
                                                value={Array.isArray(filter.value) ? filter.value.map(val => ({ label: val, value: val })) : []}
                                                onChange={(selectedOptions) => 
                                                    handleFilterChange(index, 'value', selectedOptions.map(option => option.value))
                                                }
                                                placeholder="Select"
                                                styles={{ container: (provided) => ({ ...provided, minWidth: 120, marginRight: '8px' }) }}
                                            />
                                        ):
                                        (filter.column === 'created_on' || filter.column === 'updated_on') ? (
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <TextField
                                                    select
                                                    label="Value"
                                                    value={filter.value || "today"}
                                                    onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                    sx={{ minWidth: 120,mb:1 }}
                                                >
                                                    <MenuItem value="today">Today</MenuItem>
                                                    <MenuItem value="yesterday">Yesterday</MenuItem>
                                                    <MenuItem value="this_week">This Week</MenuItem>
                                                    <MenuItem value="last_week">Last Week</MenuItem>
                                                    <MenuItem value="this_month">This Month</MenuItem>
                                                    <MenuItem value="last_month">Last Month</MenuItem>
                                                    <MenuItem value="last_3_months">Last 3 Months</MenuItem>
                                                    <MenuItem value="custom">Custom</MenuItem>
                                                </TextField>
                                                {filter.value === "custom" &&
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker 
                                                        className="filterrages mb-2"
                                                        label="Start Date"
                                                        value={filter.start_date ? dayjs(filter.start_date) : null}
                                                        onChange={(newValue) =>
                                                            handleFilterChange(
                                                            index,
                                                            "start_date",
                                                            newValue ? newValue.format("YYYY-MM-DD") : null
                                                            )
                                                        }
                                                        />

                                                        <DatePicker
                                                        label="End Date"
                                                        className="filterrages mb-2 me-2"
                                                        value={filter.end_date ? dayjs(filter.end_date) : null}
                                                        onChange={(newValue) =>
                                                            handleFilterChange(
                                                            index,
                                                            "end_date",
                                                            newValue ? newValue.format("YYYY-MM-DD") : null
                                                            )
                                                        }
                                                        />
                                                </LocalizationProvider>}
                                            </Box>
                                        ) : filter.column === 'work_authorization_expiry' || filter.column === 'dob' || filter.column === 'ead_card_applied_date' ? (
                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        {filter.operator !== "between" ? 
                                                        <DatePicker
                                                            className="filterrages mb-2"
                                                            label={"Value"}
                                                            value={filter.value ? dayjs(filter.value) : null}
                                                            onChange={(newValue) =>
                                                                handleFilterChange(
                                                                index,
                                                                "value",
                                                                newValue ? newValue.format("YYYY-MM-DD") : null
                                                                )
                                                            }
                                                        />
                                                        :<>
                                                        <DatePicker 
                                                        className="filterrages mb-2"
                                                        label="Start Date"
                                                        value={filter.start_date ? dayjs(filter.start_date) : null}
                                                        onChange={(newValue) =>
                                                            handleFilterChange(
                                                            index,
                                                            "start_date",
                                                            newValue ? newValue.format("YYYY-MM-DD") : null
                                                            )
                                                        }
                                                        />
                                                        <DatePicker
                                                        label="End Date"
                                                        className="filterrages mb-2 me-2"
                                                        value={filter.end_date ? dayjs(filter.end_date) : null}
                                                        onChange={(newValue) =>
                                                            handleFilterChange(
                                                            index,
                                                            "end_date",
                                                            newValue ? newValue.format("YYYY-MM-DD") : null
                                                            )
                                                        }
                                                        />
                                                        </>}
                                                    </LocalizationProvider>
                                                </Box>
                                            ): filter.column === 'ssn_issue_year' ?(
                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        {filter.operator !== "between" ? 
                                                        <DatePicker
                                                            views={["year"]}
                                                            openTo="year"
                                                            format="YYYY"
                                                            className="filterrages mb-2"
                                                            label="Value"
                                                            value={filter.value ? dayjs().year(parseInt(filter.value)) : null}
                                                            onChange={(newValue) => {
                                                                handleFilterChange(
                                                                    index,
                                                                    "value",
                                                                    newValue ? newValue.year().toString() : null
                                                                );
                                                            }}
                                                        />
                                                        :<>
                                                        <DatePicker
                                                            views={["year"]}
                                                            openTo="year"
                                                            format="YYYY"
                                                            className="filterrages mb-2"
                                                            label="Start Year"
                                                            value={filter.start_date ? dayjs().year(parseInt(filter.start_date)) : null}
                                                            onChange={(newValue) => {
                                                                handleFilterChange(
                                                                    index,
                                                                    "start_date",
                                                                    newValue ? newValue.year().toString() : null
                                                                );
                                                            }}
                                                        />
                                                        <DatePicker
                                                            views={["year"]}
                                                            openTo="year"
                                                            format="YYYY"
                                                            className="filterrages mb-2"
                                                            label="End Year"
                                                            value={filter.end_date ? dayjs().year(parseInt(filter.end_date)) : null}
                                                            onChange={(newValue) => {
                                                                handleFilterChange(
                                                                    index,
                                                                    "end_date",
                                                                    newValue ? newValue.year().toString() : null
                                                                );
                                                            }}
                                                        />
                                                        </>}
                                                    </LocalizationProvider>
                                                </Box>
                                            ) :filter.column === 'citizenship_status' && !(filter.operator === "is_not_one_of" || filter.operator === "is_one_of")  ? (
                                                <select
                                                    label="Value"
                                                    value={filter.value}
                                                    onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                                    sx={{ mr: 1, minWidth: 120 }}
                                                >
                                                    <option value="" disabled>Select Citizenship Status</option>
                                                    {uniqueCityStatuses.map((status) => (
                                                    <option key={status.id} value={status.status}>
                                                        {status.status}
                                                    </option>
                                                    ))}
                                                </select>
                                            ) : filter.column === 'citizenship_status' && (filter.operator === "is_not_one_of" || filter.operator === "is_one_of")  ? (
                                                <Select
                                                    isMulti
                                                    className="basic-single select_withsearch"
                                                    classNamePrefix="select"
                                                    options={uniqueCityStatuses.map(status => ({
                                                        label: status.status,
                                                        value: status.status
                                                    }))}
                                                    value={Array.isArray(filter.value) ? filter.value.map(val => ({ label: val, value: val })) : []}
                                                    onChange={(selectedOptions) => 
                                                        handleFilterChange(index, 'value', selectedOptions.map(option => option.value))
                                                    }
                                                    placeholder="Select Citizenship Status"
                                                    styles={{ container: (provided) => ({ ...provided, minWidth: 120, marginRight: '8px' }) }}
                                                />
                                            ):filter.column === 'stage' && !(filter.operator === "is_not_one_of" || filter.operator === "is_one_of")  ? (
                                                <AsyncPaginate
                                                    key={`stage-single-${index}`}
                                                    isClearable
                                                    className="basic-select select_withsearch"
                                                    classNamePrefix="select"
                                                    loadOptions={loadOptionsStages}
                                                    value={
                                                        filter.value
                                                            ? stageOptions.find(opt => opt.value === filter.value) || {
                                                                label: filter.value,
                                                                value: filter.value
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selectedOption) =>
                                                        handleFilterChange(
                                                            index,
                                                            'value',
                                                            selectedOption ? selectedOption.value : ""
                                                        )
                                                    }
                                                    placeholder="Choose Stage..."
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                    debounceTimeout={300}
                                                    cacheUniqs={[]}
                                                    reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]}
                                                />
                                            ) : filter.column === 'stage' && (filter.operator === "is_not_one_of" || filter.operator === "is_one_of")  ? (
                                                <AsyncPaginate
                                                    key={`stage-multi-${index}`}
                                                    isMulti
                                                    isClearable
                                                    className="basic-multi-select select_withsearch"
                                                    classNamePrefix="select"
                                                    loadOptions={loadOptionsStages}
                                                    value={
                                                        Array.isArray(filter.value)
                                                            ? filter.value.map(val => {
                                                                const option = stageOptions.find(opt => opt.value === val);
                                                                return option || { label: val, value: val };
                                                            })
                                                            : []
                                                    }
                                                    onChange={(selectedOptions) => 
                                                        handleFilterChange(index, 'value', selectedOptions.map(option => option.value))
                                                    }
                                                    placeholder="Choose Stages..."
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                    debounceTimeout={300}
                                                    cacheUniqs={[]}
                                                    reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]} 
                                                />
                                            ):filter.column === 'sub_stage' && !(filter.operator === "is_not_one_of" || filter.operator === "is_one_of")  ? (
                                                <AsyncPaginate
                                                    key={`sub-stage-single-${index}`}
                                                    isClearable
                                                    className="basic-select select_withsearch"
                                                    classNamePrefix="select"
                                                    loadOptions={loadOptionsSubStages}
                                                    value={
                                                        filter.value
                                                            ? subStageOptions.find(opt => opt.value === filter.value) || {
                                                                label: filter.value,
                                                                value: filter.value
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selectedOption) =>
                                                        handleFilterChange(
                                                            index,
                                                            'value',
                                                            selectedOption ? selectedOption.value : ""
                                                        )
                                                    }
                                                    placeholder="Choose Sub Stage..."
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                    debounceTimeout={300}
                                                    cacheUniqs={[]}
                                                    reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]}
                                                />
                                            ) : filter.column === 'sub_stage' && (filter.operator === "is_not_one_of" || filter.operator === "is_one_of")  ? (
                                                <AsyncPaginate
                                                    key={`sub-stage-multi-${index}`}
                                                    isMulti
                                                    isClearable
                                                    className="basic-multi-select select_withsearch"
                                                    classNamePrefix="select"
                                                    loadOptions={loadOptionsSubStages}
                                                    value={
                                                        Array.isArray(filter.value)
                                                            ? filter.value.map(val => {
                                                                const option = subStageOptions.find(opt => opt.value === val);
                                                                return option || { label: val, value: val };
                                                            })
                                                            : []
                                                    }
                                                    onChange={(selectedOptions) => 
                                                        handleFilterChange(index, 'value', selectedOptions.map(option => option.value))
                                                    }
                                                    placeholder="Choose Sub Stages..."
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                    debounceTimeout={300}
                                                    cacheUniqs={[]}
                                                    reduceOptions={(prevOptions, loadedOptions) => [...prevOptions, ...loadedOptions]} 
                                                />
                                            ):(
                                            <input
                                                className='value_inputfilter mb-2'
                                                placeholder='Value'
                                                label="Value"
                                                value={filter.value}
                                                onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                            />
                                        )}</>}
                                    <button className='filterremovebtn mb-2 ms-1' onClick={() => removeFilter(index)}>Remove</button>
                                </Box>
                            ))}
                            <button className='registersendbtn1 mt-2 mb-0' onClick={addFilter}>Add Filter</button>
                            <button className='registersendbtn2 mt-2 mb-0 ms-3' onClick={handleSearchTable}>
                                {loadingApply ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Apply'}
                            </button>
                        </Box>)}
                        <Grid size={{xs:12}} container justifyContent="space-between">
                            <div className='d-flex gap-3'>
                                {!showLaneview &&
                                <button className='show_filterbtn' onClick={toggleGrid}>
                                    {isGridVisible ?<> Hide Filter <FontAwesomeIcon icon={faFilterCircleXmark} /> </> :<> Show Filter <FontAwesomeIcon icon={faFilter} /> </>}
                                </button>}
                                <button className='registersendbtn2 my-0' onClick={toggleLaneview} >
                                    {showLaneview ? "Table view" : "Lane View" }
                                </button>
                            </div>
                            {!showLaneview &&
                            <div className='d-flex gap-3'>
                                <button className='download_csvbtndatatable' onClick={copyToClipboard}>Copy Table <FontAwesomeIcon className='ps-2' icon={faCopy} /></button>
                                <button className='download_csvbtndatatable' onClick={downloadCSV}>Download CSV<FontAwesomeIcon className='ps-2' icon={faCircleDown} /></button>
                            </div>}
                        </Grid>
                    </Box>
                    {loadingPage ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    {(seekerData && seekerData.length === 0) ?
                    <span className='w-100 text-center'>No Data</span> :
                    <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi select_searchindex">
                        {!showLaneview ? (
                            <DataGrid
                                style={{minHeight:"200px"}}
                                rows={rows}
                                columns={columns}
                                disableSelectionOnClick
                                components={{ Toolbar: GridToolbar }}
                                columnVisibilityModel={columnVisibilityModel}
                                onColumnVisibilityModelChange={(newModel) => setColumnVisibilityModel(newModel)}
                            />
                            ) : (
                                loadingLanedata ? 
                                    <div className='d-flex justify-content-center w-100'>
                                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                                    </div> :<>
                                <Box sx={{ mt: 2 }}>
                                    <Grid size={{xs:12}} container className="d-flex align-items-start flex-wrap gap-3 mb-3 select_index_muilabel">
                                        <Grid size={{xs:2.8}} container flexDirection="column">
                                            <label style={{ display: 'block', marginBottom: '4px' }}>Group By</label>
                                            <select
                                                value={groupByColumn}
                                                onChange={(e) => setGroupByColumn(e.target.value)}
                                                className="form-select"
                                                style={{ maxWidth: '100%', display: 'inline-block' }}
                                            >
                                                {groupByOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </Grid>
                                        <Grid size={{xs:2.8}} container flexDirection="column">
                                            <label style={{ display: 'block', marginBottom: '4px' }}>Onboarding Hold</label>
                                            <select
                                                value={selectedOnboard}
                                                onChange={(e) => setSelectedOnboard(e.target.value)}
                                                className="form-select"
                                                style={{ maxWidth: '100%', display: 'inline-block' }}
                                            >
                                                <option value="">Include</option>
                                                <option value="Exclude">Exclude</option>
                                                <option value="Only">Only</option>
                                            </select>
                                        </Grid>
                                        <Grid size={{xs:2.8}} container flexDirection="column">
                                            <label style={{ display: 'block', marginBottom: '4px' }}>Training Status</label>
                                            <select
                                                value={trainStatus}
                                                onChange={(e) => setTrainStatus(e.target.value)}
                                                className="form-select"
                                                style={{ maxWidth: '100%', display: 'inline-block' }}
                                            >
                                                <option value="">Include</option>
                                                <option value="Exclude">Exclude</option>
                                                <option value="Only">Only</option>
                                            </select>
                                        </Grid>
                                        <Grid size={{xs:12}} container className="mt-2 mb-3 gap-3">
                                            <button className='registersendbtn2 my-0' onClick={handleSearch}>{loadingApply2 ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Apply'}</button>
                                            <button className='registersendbtn1 my-0' onClick={handleClear}>Clear</button>
                                        </Grid>
                                    </Grid>
                                    {seekerData2.length > 0 ? (
                                        <div className="d-flex mt-3 g-3 scrum_view">
                                            {seekerData2.map((value, index) => {
                                                // const SeekerGroup = groupedGcase()[value] || [];
                                                const columnSize = 'scrum_viewwidthwhole';
                                                
                                                return (
                                                    <div key={index} className={`${columnSize} p-2`}>
                                                        <div className="scrum-column">
                                                            <h6 className="scrum-title">{value.title}</h6>
                                                            <div className="scrum-count">{value.total}</div>
                                                            <div className="scrum-cards">
                                                                {value?.data?.map((SeekerLaneData, index) => (
                                                                    <MySeekerCard key={index} SeekerLaneData={SeekerLaneData} />
                                                                ))}
                                                                <div ref={setObserver(value.group_id, value.has_more)} />

                                                                    {/* 👇 Per-lane loading spinner */}
                                                                    {laneLoading[value.group_id] && (
                                                                        <div className="text-center py-2">
                                                                            <span className="spinner-border spinner-border-sm" />
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div className="text-center p-4">
                                            <p>No Data.</p>
                                        </div>
                                    )}
                                </Box>
                            </>
                        )}
                        {!showLaneview && <>
                            <Grid size={{xs:12}} container justifyContent="space-between">
                                <div className='d-flex justify-content-end align-items-center mt-3'>
                                    <label className='me-2'>Showing records <b>{paginatedata.from}</b>-<b>{paginatedata.to}</b> out of <b>{paginatedata.total}</b></label>
                                </div>
                                <div className='d-flex justify-content-end align-items-center mt-3'>
                                    <label className='me-2'>No. of Rows</label>
                                    <select
                                        label="Rows per page"
                                        value={selectedRecord || 20}
                                        onChange={(e) => {
                                            const value = Number(e.target.value);
                                            setShowRecord(value);
                                            setCurrentPage(1);
                                            fetchRoots({ per_page: value, filters: applyFilData });
                                        }}
                                        sx={{ mr: 2 }}
                                    >
                                        {[5, 10, 20, 50].map((size) => (
                                            <option key={size} value={size}>{size}</option>
                                        ))}
                                    </select>
                                </div>
                            </Grid>
                            <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange(currentPage - 1)} 
                                    disabled={currentPage === 1}>
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                                {paginatedata && paginatedata.last_page > 0 && (
                                    <div className="pagination">
                                        {(() => {
                                        const totalPages = Math.max(1, paginatedata.last_page);
                                        const pages = [];

                                        const start = Math.max(2, currentPage - 2);
                                        const end = Math.min(totalPages - 1, currentPage + 2);

                                        // Always show page 1
                                        pages.push(
                                            <button
                                            key={1}
                                            onClick={() => handlePageChange(1)}
                                            className={currentPage === 1 ? 'active' : ''}
                                            >
                                            1
                                            </button>
                                        );

                                        // Ellipsis after page 1 if needed
                                        if (start > 2) {
                                            pages.push(<span key="start-ellipsis">...</span>);
                                        }

                                        // Middle pages
                                        for (let i = start; i <= end; i++) {
                                            pages.push(
                                            <button
                                                key={i}
                                                onClick={() => handlePageChange(i)}
                                                className={currentPage === i ? 'active' : ''}
                                            >
                                                {i}
                                            </button>
                                            );
                                        }

                                        // Ellipsis before last page if needed
                                        if (end < totalPages - 1) {
                                            pages.push(<span key="end-ellipsis">...</span>);
                                        }

                                        // Always show last page (if more than 1)
                                        if (totalPages > 1) {
                                            pages.push(
                                            <button
                                                key={totalPages}
                                                onClick={() => handlePageChange(totalPages)}
                                                className={currentPage === totalPages ? 'active' : ''}
                                            >
                                                {totalPages}
                                            </button>
                                            );
                                        }

                                        return pages;
                                        })()}
                                    </div>
                                )}
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange(currentPage + 1)} 
                                    disabled={currentPage === paginatedata.last_page}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </Grid></>
                        }
                    </Box>
                    }</>}
                </>}
            </Grid>
            <ExportDialogs
                exporting={exporting}
                prompt={prompt}
                onEmail={confirmEmail}
                onContinue={confirmContinue}
                onCancel={cancelPrompt}
                loaderSrc={require('../../assets/pinkloader.gif')}
            />
        </div>
    </div>
  )
}

export default UserJobSeekers